import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = { class: "DialogSection" }
const _hoisted_5 = { class: "DialogSection" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1)
const _hoisted_7 = { class: "DialogSection" }
const _hoisted_8 = { class: "DialogSection" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_10 = { class: "DialogSection" }
const _hoisted_11 = {
  key: 0,
  class: "CookiesDialogFooter"
}
const _hoisted_12 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesSearchInput = _resolveComponent("CookiesSearchInput")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_CookiesNormalInput, {
              Res: 'D_MainCategories_Name',
              Placeholder: _ctx.Translate('Name')
            }, null, 8, ["Placeholder"]),
            _createVNode(_component_CookiesNormalInput, {
              Res: 'D_MainCategories_Notes',
              Placeholder: _ctx.Translate('Notes')
            }, null, 8, ["Placeholder"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.NewCategory())),
                class: "CookiesButton BGMain F-Bold"
              }, [
                _createVNode(_component_CookiesIcon, {
                  class: "M-Auto SQR1_5em",
                  style: {"padding-inline-end":"0.5em"},
                  ID: 'Add'
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.Translate('Add New')), 1)
              ])
            ])
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_CookiesSearchInput, {
              Res: 'D_MainCategories_Search',
              Placeholder: _ctx.Translate('Search...')
            }, null, 8, ["Placeholder"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_CookiesTable, {
              onImageChanged: _ctx.ImageChanged,
              onFieldEdited: _ctx.FieldEdited,
              onDeleteRow: _ctx.RemoveItem,
              class: "Shadow1",
              TableSettings: _ctx.TableSettings,
              CookiesData: _ctx.CookiesData,
              Search: _ctx.MEMRead('D_MainCategories_Search'),
              Loading: (_ctx.Loading.length > 0),
              Saving: (_ctx.Saving.length > 0),
              Saved: _ctx.Saved
            }, null, 8, ["onImageChanged", "onFieldEdited", "onDeleteRow", "TableSettings", "CookiesData", "Search", "Loading", "Saving", "Saved"])
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.NewCategory())),
                class: "CookiesButton BGMain F-Bold"
              }, [
                _createVNode(_component_CookiesIcon, {
                  class: "M-Auto SQR1_5em",
                  style: {"padding-inline-end":"0.5em"},
                  ID: 'Add'
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.Translate('Add New')), 1)
              ])
            ])
          ])
        ])
      ])
    ], 8, _hoisted_1),
    (_ctx.Access('Main_Categories_Edit'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Close')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}